import React, { useRef, useState, useEffect } from 'react'

const UploadByCamera = ({
  onError,
  onUpload,
  className,
  buttonClassName = 'btn',
  label = 'Take Photo',
  disabled = undefined,
  maxFileSize = 10 * 1024 * 1024, // Default max file size 10 MB
  mediaAccepted = [`image/*`],
}) => {
  const [windowSize, setWindowSize] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1200,
  )
  const fileInputRef = useRef(null)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleResize = () => setWindowSize(window.innerWidth)
      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
    }
  }, [])

  const handleButtonClick = () => {
    fileInputRef.current.click() // Trigger click on hidden input
  }
  const handleUpload = e => {
    const {
      target: { files },
    } = e
    if (files[0].size > maxFileSize) {
      onError('file-too-large')
    } else {
      onUpload(files)
    }
  }

  return windowSize <= 900 ? (
    <div className={`${className}`}>
      <button
        className={`${buttonClassName}`}
        disabled={disabled}
        onClick={handleButtonClick}
      >
        <span>{label}</span>
        <input
          type="file"
          ref={fileInputRef}
          accept={mediaAccepted.join(', ')}
          capture="environment"
          multiple={false}
          onChange={handleUpload}
          style={{ display: 'none' }}
        />
      </button>
    </div>
  ) : (
    <></>
  )
}

export default UploadByCamera
